<template>
  <div class="base-info-container">
    <el-card>
      <template #header>
        <TitleItem title="基本信息" />
      </template>
      <el-form ref="baseInfoForm" :model="baseInfoModel" :rules="rules" label-width="125px">
        <el-form-item label="套餐分类" required>
          <template v-if="cateModel">
            <span>{{ cateModel.classificationFullName }}&nbsp;&nbsp;</span>
            <el-button type="text" @click="changeCate"> 修改类目</el-button>
          </template>
          <el-button v-else type="text" @click="changeCate">选择类目</el-button>
          <p class="cate-tips">准确选择货品分类有助于完善货品信息和精准推送到商城分类</p>
        </el-form-item>

        <el-form-item label="套餐名称" prop="name">
          <el-input style="width: 203px" v-model="baseInfoModel.name" maxlength="30" placeholder="请输入套餐名称(至多30字)"></el-input>
        </el-form-item>
        <el-form-item label="自定义分类">
          <el-select v-model="baseInfoModel.goodsType" placeholder="请选择自定义分类">
            <el-option v-for="cateItem in customCateList" :label="cateItem.name" :value="cateItem.shopDecorateId" :key="cateItem.shopDecorateId"></el-option>
          </el-select>
          <el-button type="text" class="mar10-l" @click="toShopClassify">新建自定义分类</el-button>
        </el-form-item>
        <el-form-item label="套餐商品" required>
          <el-button type="text" @click="selectGoodsList">选择商品</el-button>
          <el-table
            v-if="checkGoodsList.length"
            ref="multipleTable"
            :data="checkGoodsList"
            tooltip-effect="dark"
            style="width: 100%"
            class="mar20_b"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="商品信息" width="300">
              <template #default="scope">
                <div class="client_list_wrap">
                  <ul class="clear" style="width: 670px">
                    <li style="width: 300px">
                      <img
                        class="float-left appoint_good_img"
                        :src="scope.row.picUrl"
                        alt=""
                        style="width: 80px; height: 80px; border-radius: 5px; margin-right: 10px"
                      />
                      <div style="width: 250px">
                        <p class="ellipsis f14">{{ scope.row.name }}</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="marketPriceStr" label="市场价" width="90"> </el-table-column>
            <el-table-column label="套餐内价格" width="150">
              <template #default="scope">
                <el-input
                  v-model="scope.row.groupGoodsPrice"
                  @blur="scope.row.groupGoodsPrice = formatNums(scope.row.groupGoodsPrice, true)"
                  @change="countPrice()"
                >
                  <template slot="prepend">￥</template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template #default="scope">
                <el-button type="text" @click="deleteRow(scope.$index, checkGoodsList)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div v-if="checkGoodsList.length > 0" class="hejimoney flex">
            <span class="hejimoneyspan">合计：{{ checkGoodsList.length }}件</span>
            <span>套餐价格合计：{{ marketPrice }}</span>
          </div>
          <div v-if="checkGoodsList.length > 0" style="margin-top: 20px">
            <span>已选</span>
            <el-button type="text">{{ multipleSelection.length }}</el-button>
            <span class="mar20-r">项</span>
            <el-button type="primary" plain @click="deleteSel">删除</el-button>
          </div>
        </el-form-item>
      </el-form>

      <el-dialog
        title="选择商品"
        :visible.sync="chooseGoodVisible"
        :close-on-click-modal="false"
        width="1140px"
        top="80px"
        :show-close="false"
        custom-class="chooseGoodPop"
      >
        <div>
          <div class="clear ps_search_wrap">
            <span class="float-left pad15_r lin_30 inlineblock">商品名称</span>
            <div class="ps_search float-left">
              <el-input type="text" placeholder="请输入商品名称" v-model="searchGoods.name"> </el-input>
            </div>
            <div class="float-left client_pop_query">
              <el-button type="primary" @click="listShopGoods(1)">搜索</el-button>
            </div>
          </div>
          <div class="clear appoint_goods_list">
            <div class="float-left client_list_all">
              <p>商品信息</p>
              <div class="client_list_wrap">
                <ul class="clear">
                  <li v-for="(item, index) in goodsDataList" :key="index" @click="goodsDialogSelect(item)">
                    <img class="float-left appoint_good_img" :src="item.picUrl" alt="" />
                    <div class="float-left appoint_good_main">
                      <p class="ellipsis f14">{{ item.name }}</p>
                      <p class="f12">规格：{{ item.spec }}</p>
                      <p class="f12">原价：¥{{ item.marketPriceStr }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="float-right client_list_me">
              <p>已选商品</p>
              <div class="client_list_wrap">
                <ul class="clear">
                  <li v-for="(item, index) in goodsSelectList" :key="index">
                    <i class="iconfont icon-shibai fb" @click="removeSelectGoods(index)"></i>
                    <img class="float-left appoint_good_img" :src="item.picUrl" alt="" />
                    <div class="float-left appoint_good_main">
                      <p class="ellipsis f14">{{ item.name }}</p>
                      <p class="f12">规格：{{ item.spec }}</p>
                      <p class="f12">原价：¥{{ item.marketPriceStr }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="box10"></div>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="goodsDialogConfirm">确 认</el-button>
          <el-button @click="chooseGoodVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </el-card>
    <SelectCateDialog v-if="showSelectCate" :showSelectCate.sync="showSelectCate" />
  </div>
</template>

<script>
import { getGoodsShopCategory } from "@/api/publishGoods/publishGoods";
import { createNamespacedHelpers } from "vuex";
import TitleItem from "./TitleItem.vue";
import SelectCateDialog from "./SelectCateDialog.vue";

const { mapState } = createNamespacedHelpers("publishGoods/publishGoods");

export default {
  components: {
    TitleItem,
    SelectCateDialog,
  },
  data() {
    return {
      showSelectCate: false,
      isShowOA: false,
      customCateList: [],
      baseInfoModel: {
        name: "",
        goodsType: "",
        isoa: 0,
      },
      rules: {
        name: [
          { required: true, message: "请输入套餐名称", trigger: "blur" },
          { min: 1, max: 30, message: "长度在 1 到 30 个字", trigger: "blur" },
        ],
      },
      pageSize: 10, // 商品列表页分页大小
      currentPage: 1, // 商品列表页当前分页
      totalCount: 0, // 商品列表页商品总数
      goodsDataList: [], // 店铺商品列表
      goodsSelectList: [], // 店铺商品选中列表
      checkGoodsList: [], // 选择的商品
      searchGoods: {
        name: "",
        axis: "",
        pageNum: 1,
        pageSize: 10,
        isoa: 0,
        status: "5",
        isGroup: 1,
        isVip: 0,
      },
      chooseGoodVisible: false,
      marketPrice: "", // 价格
      multipleSelection: [],
    };
  },
  computed: {
    ...mapState(["cateModel", "goodsDetail", "spuId", "shopConfig"]),
  },
  created() {
    this.loadGetGoodsShopCategory();
  },
  watch: {
    goodsDetail(newVal) {
      this.$store.dispatch("publishGoods/publishGoods/setCateModel", {
        classificationFullName: newVal.categoryAxis,
        id: newVal.firstSku.categoryId,
        axis: newVal.firstSku.axis,
      });
      this.baseInfoModel.name = newVal.firstSku.name;
      this.baseInfoModel.goodsType = newVal.shopClassifyId;
      this.baseInfoModel.isoa = newVal.firstSku.isoa;
      this.checkGoodsList = newVal.packageGoodsList;
      this.marketPrice = newVal.firstSku.marketPriceStr;
    },
    shopConfig(newVal) {
      //新增商品时,不展示企联网
      if (this.spuId) {
        this.isShowOA = newVal.isoa == 1 && newVal.shopDtlEntity.isSetGoodsOa == 1;
      }
    },
    checkGoodsList: {
      handler(newName, oldName) {
        console.log("watch==datas", newName, oldName);
        const totalvalue = newName.reduce((total, item) => total + 10000 * (item.groupGoodsPrice || 0), 0);
        this.marketPrice = totalvalue / 10000;
      },
      deep: true,
    },
  },
  methods: {
    async loadGetGoodsShopCategory() {
      const result = await getGoodsShopCategory();
      this.customCateList = result.data;
    },
    changeCate() {
      this.showSelectCate = true;
    },
    async subMitCheck() {
      if (!this.cateModel) {
        this.$message.error("请选择套餐分类");
        return;
      }

      try {
        await this.$refs.baseInfoForm.validate();
      } catch (error) {
        this.$message.error("请输入套餐名称");
        return;
      }

      try {
        // 套餐商品
        let goodsPackageInfoList = [];
        if (this.checkGoodsList.length <= 0) {
          this.$message.error("请选择套装商品");
          return;
        }
        // 主商品
        let mainGoods = this.checkGoodsList[0];
        this.checkGoodsList.forEach(function (goods) {
          if (goods.groupGoodsPrice == null || goods.groupGoodsPrice == "" || !(Number(goods.groupGoodsPrice) > 0)) {
            throw new Error("请输入商品价格，商品价格必须大于0");
          }
          let goodsPackageInfo = {};
          goodsPackageInfo.mainGoodsId = mainGoods.goodsId;
          goodsPackageInfo.additionalGoodsId = goods.goodsId;
          goodsPackageInfo.additionalGoodsPrice = goods.groupGoodsPrice;
          goodsPackageInfo.additionalGoodsNum = 1;
          goodsPackageInfoList.push(goodsPackageInfo);
        });
        const baseInfoObj = {
          categoryId: this.cateModel.id,
          axis: this.cateModel.axis,
          name: this.baseInfoModel.name,
          goodsType: this.baseInfoModel.goodsType,
          isoa: this.baseInfoModel.isoa,
          goodsPackageInfoListJson: JSON.stringify(goodsPackageInfoList),
          marketPrice: this.marketPrice,
        };
        return baseInfoObj;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 点击添加货品
    selectGoodsList() {
      this.listShopGoods(2);
      this.goodsSelectList = [];
      this.checkGoodsList.forEach((goods) => {
        this.goodsSelectList.push(goods);
      });
    },

    // 查询店铺全部在售非oa商品
    listShopGoods(type) {
      if (type) {
        this.currentPage = 1;
      }
      this.searchGoods.pageNum = this.currentPage;
      this.searchGoods.pageSize = this.pageSize;
      this.$store.dispatch("goods/goods/getShopGoodsList", this.searchGoods).then((data) => {
        if (data && data.goodsList) {
          // 初始化数据
          data.goodsList.forEach((goods) => {
            goods.sponsorPrice = goods.marketPriceStr; // 团长价
            goods.goodsPrice = ""; // 拼团价
            goods.peopleLimit = 2; // 成团人数
            goods.goodsQuantity = goods.currQuantity; // 活动商品数
            goods.volumeLimit = ""; // 开团次数
          });
          this.goodsDataList = data.goodsList;
          this.totalCount = data.totalCount;
        }
        if (type === 2) {
          if (this.goodsDataList.length === 0) {
            this.$message.error("无货品数据,请添加货品");
            return;
          }
          this.chooseGoodVisible = true;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    deleteSel() {
      if (!this.multipleSelection.length) {
        this.$message.error("至少选中一条商品！");
        return;
      }
      var tableList = [];
      for (let val of this.checkGoodsList) {
        if (this.multipleSelection.findIndex((va) => va == val) == "-1") {
          tableList.push(val);
        }
      }
      this.checkGoodsList = tableList;
      this.$refs.multipleTable.clearSelection();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.listShopGoods();
    },
    // 确定选择商品
    goodsDialogConfirm() {
      this.checkGoodsList = [];
      this.goodsSelectList.forEach((goods) => {
        this.checkGoodsList.push(goods);
      });
      // compensationCouponList
      this.chooseGoodVisible = false;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.listShopGoods();
    },
    // 商品列表页点击商品
    goodsDialogSelect(goods) {
      const index = this.goodsSelectList.findIndex((g) => goods.goodsId === g.goodsId);
      if (index < 0) {
        this.goodsSelectList.push(goods);
      }
    },
    // 删除选择商品弹框中已选择商品
    removeSelectGoods(index) {
      this.goodsSelectList.splice(index, 1);
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    formatNums(nums, decimal) {
      let value = `${nums}`;
      value = value.replace(/[^\d.]/g, "");
      value = value.replace(/\.{2,}/g, ".");
      value = value.replace(".", "$#$");
      value = value.replace(/\./g, "");
      value = value.replace("$#$", ".");
      const reg = new RegExp("^(-)?(\\d{1,8})\\.(\\d{0,4}).*$");
      value = value.replace(reg, "$1$2.$3");
      console.info(value);
      if (value.indexOf(".") < 0 && value !== "" && value !== "-") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value);
      }
      if (value && !decimal) {
        value = parseInt(value, 10);
      }
      if (value === 0) {
        return "";
      }
      return value;
    },
    countPrice() {},
    toShopClassify() {
      console.log("分类：", `${process.env.VUE_APP_APP}classify/toShopClassify.do?appid=1`);
      if (self != top) {
        window.parent.postMessage(
          {
            fn: "open",
            data: {
              url: `${process.env.VUE_APP_APP}classify/toShopClassify.do?appid=1&isShowTitle=1`,
              title: "商品分类",
              target: 0,
            },
          },
          "*"
        );
      } else {
        window.open(`${process.env.VUE_APP_APP}classify/toShopClassify.do?appid=1&isShowTitle=1`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hejimoney {
  background-color: #eee;
  color: #333;
}
.hejimoneyspan {
  width: 400px;
  margin-left: 50px;
}
.base-info-container {
  padding-top: 20px;
  .cate-tips {
    color: grey;
    line-height: 1.2;
    font-size: 12px;
  }
}
.chooseGoodPop {
  .client_list_wrap {
    border-radius: 10px;
    box-shadow: 0 0 15px #ccc;
    padding: 10px;
    margin-top: 30px;
  }
  ul {
    max-height: 430px;
    overflow: auto;
    padding: 20px;
    &::-webkit-scrollbar {
      width: 5px; /*对垂直流动条有效*/
    }
  }
  li {
    cursor: pointer;
    width: 300px;
    /*margin-right: 30px;*/
    .appoint_good_main {
      width: 160px;
    }
  }
  .client_list_all {
    ul {
      width: 670px;
    }
    li:nth-child(2n-2) {
      margin-right: 0;
    }
  }
  .client_list_me {
    ul {
      width: 340px;
    }
    li {
      margin-right: 0;
    }
  }
  .ps_search_wrap {
    width: 1000px;
    margin-bottom: 30px;
    .ps_search {
      width: 230px;
      display: inline-block;
    }
  }
  .client_list_all {
    ul {
      width: 670px;
    }
    li:nth-child(2n-2) {
      margin-right: 0;
    }
  }
  .appoint_goods_list {
    li {
      float: left;
      width: 273px;
      height: 110px;
      padding: 15px 20px;
      border-radius: 5px;
      color: #222;
      box-shadow: 0 0 15px #ccc;
      margin: 0 15px 20px 0;
      position: relative;
      &:nth-child(4n-4) {
        margin-right: 0;
      }
      i {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
      }
    }
    .appoint_good_img {
      width: 80px;
      height: 80px;
      border-radius: 5px;
      margin-right: 10px;
    }
    .appoint_good_main {
      width: 136px;
      input {
        font-size: 12px;
        width: 120px;
        height: 24px;
        margin: 0;
      }
    }
  }
  .client_pop_query {
    width: 70px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #fff;
    background-color: #ff0023;
    border-radius: 3px;
    margin-left: 30px;
    cursor: pointer;
  }
}
</style>
